import { Dialog, DialogCloseButton } from "@/components/dialog";
import { Modal } from "@/components/modal";

import type { AssetFileRef } from "./types";

import { AssetFileTile } from "./AssetFileTile";

type AllFilesModalProps = {
  files: AssetFileRef[];
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  onPreview: (attachmentId: number) => void;
  onRemoveFile?: (attachmentId: number) => void;
  title: string;
};

export function AllFilesModal({
  files,
  isOpen,
  onOpenChange,
  onPreview,
  onRemoveFile,
  title,
}: AllFilesModalProps) {
  return (
    <Modal
      classNames={{ modal: "w-[800px] max-w-[calc(100vw-48px)]" }}
      isDismissable
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog className="flex max-h-[80vh] flex-col">
        <DialogCloseButton />
        <h2 className="px-3xl pt-3xl text-lg font-semibold text-text-primary">
          {title} ({files.length})
        </h2>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(128px,1fr))] gap-x-xl gap-y-[18px] overflow-y-auto p-3xl">
          {files.map((file) => (
            <AssetFileTile
              file={file}
              key={file.attachmentId}
              onPreview={onPreview}
              onRemove={onRemoveFile}
            />
          ))}
        </div>
      </Dialog>
    </Modal>
  );
}
